export default class Category {
  constructor(data) {
    if (data && data.fields) {
      const { category } = data.fields;
      this.category = category;
    }
  }
}
